<template>
  <v-card
    :flat="isFlat"
    class="py-3 mt-3"
  >
    <form-group
      title="Dados pessoais informados pelo usuário"
    >
      <v-row>
        <documents-validate-data-view
          v-model="payload"
          :loading="isLoading"
        />
      </v-row>
      <v-row>
        <v-col cols="6">
          <client-personal-data-view
            v-model="payload.dataByUser"
            :loading="isLoading"
            :compare="compareUserData"
            :omits="['fathersName', 'rg']"
            autofill="Não informado"
          />
        </v-col>
        <v-col cols="6">
          <address-data-view
            v-model="payload.personalAddress"
            :loading="isLoading"
            autofill="Não informado"
          />
        </v-col>
      </v-row>
    </form-group>
    <form-group>
      <v-row>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
    </form-group>
    <form-group title="Dados da empresa informados pelo usuário">
      <v-row>
        <v-col cols="6">
          <company-data-view
            v-model="payload.companyDataByUser"
            :loading="isLoading"
            autofill="Não informado"
          />
        </v-col>
        <v-col cols="6">
          <address-data-view
            v-model="payload.businessAddress"
            :loading="isLoading"
            autofill="Não informado"
          />
        </v-col>
      </v-row>
    </form-group>
  </v-card>
</template>

<script>
import DocumentsValidateDataView from 'Modules/contacard/analysisTable/components/dataViews/DocumentsValidateDataView.vue';
import ClientPersonalDataView from 'Modules/contacard/analysisTable/components/dataViews/ClientPersonalDataView.vue';
import AddressDataView from 'Modules/contacard/analysisTable/components/dataViews/AddressDataView.vue';
import AnalysisCardMixin from 'Modules/contacard/analysisTable/components/cards/AnalysisCardMixin';
import CompanyDataView from 'Modules/contacard/analysisTable/components/dataViews/CompanyDataView.vue';

export default {
  name: 'ClientCompanyInfoCard',
  components: {
    DocumentsValidateDataView,
    ClientPersonalDataView,
    AddressDataView,
    CompanyDataView,
  },
  mixins: [AnalysisCardMixin],
};
</script>
